<p-toast position="top-right" [preventOpenDuplicates]="true" styleClass="eq-toast" />
<router-outlet />
